import axios from "axios"
import { fetchAccessToken } from "../utils/token"
import { BRIDGE_URL } from "../utils/constants"


// Fetch available staff for selected store
export const getAppointmentDetail = async (appointmentId) => {

    try {

        const token = localStorage.getItem("oss-token")
        if(!token) fetchAccessToken()


        const headers = {
            Authorization: `Bearer ${token}`
        }

        const res = await axios.get(`${BRIDGE_URL(`services/apexrest/appointment/existing/?appointmentId=${appointmentId}`)}`, { headers })
        if(typeof res.data === "string") return []
        return res.data

    } catch (err) {
        console.log(err)
    }

}
